
var griddarrow  = ['<svg xmlns="http://www.w3.org/2000/svg" width="17.844" height="30.35" viewBox="0 0 17.844 30.35"><defs><style>.cls-1 {fill: #b2b2b2;fill-rule: evenodd;}</style></defs><path id="Shape_672_copy_10" data-name="Shape 672 copy 10" class="cls-1" d="M181.13,2116.14l-11.85,11.59,11.85,11.59-2.354,3.58-15.508-15.17,15.508-15.16Z" transform="translate(-163.281 -2112.56)"/></svg>' , '<svg xmlns="http://www.w3.org/2000/svg" width="17.85" height="30.343" viewBox="0 0 17.85 30.343"><defs><style>.cls-1 {fill: #b2b2b2;fill-rule: evenodd;}</style></defs><path id="Shape_672_copy_8" data-name="Shape 672 copy 8" class="cls-1" d="M1850.06,398.522l11.85,11.587-11.85,11.59,2.35,3.574,15.51-15.164-15.51-15.16Z" transform="translate(-1850.06 -394.938)"/></svg>'];
$(window).on('load', function(){


    $('.related-caro').owlCarousel({
        loop:false,
        margin:30,
        nav:true,
        navText : griddarrow,
        responsive:{
            0:{
                items:1
            },
            1200:{
                items:2
            },
            1400:{
                items:3
            }
        }
    })

});

